import React,{useState,useEffect} from 'react'
import logo from "./../../assets/images/logo.png";
import { IoMdBus } from "react-icons/io";
import { BiLoaderAlt } from "react-icons/bi";
const Loader = () => {
    
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    // simulate an async action
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, []); // pass an empty array to only run this effect once

  return (
    <>
    
    <div>
        {isLoading ? (
          <div className="mainContainerLoader">
            <img src={logo} className="logoAlertImg" />

            {/* <div className="alertTxt">Please wait .....</div> */}

            <div className="topLoaderIconsAlert">
              <IoMdBus className="busIcon" />
              <BiLoaderAlt className="loaderIconAlert" />
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  )
}

export default Loader